// The rendered contract is the white page(s) only. The gray "desk" framing is presentation
// chrome owned by the display layer, injected (screen-only, so it never reaches the PDF) into
// the isolated iframe document. On a narrow viewport the outer frame drops away, but the gray
// gap between pages stays as a page-break separator.
const DISPLAY_CHROME = `<style>
  @media screen {
    html { background: #e9e9ec; }
    body { padding: 32px 0; }
    .page {
      margin: 0 auto 28px;
      box-shadow: 0 1px 4px rgba(0,0,0,.12), 0 8px 28px rgba(0,0,0,.10);
    }
  }
  @media screen and (max-width: 794px) {
    body { padding: 0; }
    .page { margin: 0 auto; box-shadow: none; }
    .page + .page { margin-top: 28px; }
  }
</style>`;

export const withDisplayChrome = (html: string): string =>
  html.includes("</head>")
    ? html.replace("</head>", `${DISPLAY_CHROME}</head>`)
    : `${DISPLAY_CHROME}${html}`;
